import { render, staticRenderFns } from "./OrderRetailDetail.vue?vue&type=template&id=c8fcf706&scoped=true&"
import script from "./OrderRetailDetail.vue?vue&type=script&lang=js&"
export * from "./OrderRetailDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fcf706",
  null
  
)

export default component.exports